import React from 'react'
import { DumbField, getValidityClass } from 'components/Wizard2/Field'
import { TextInput, Select, RadioInput } from 'components/Wizard2/fieldComponents/Form'
import { AddressBlock } from 'components/Wizard2/fieldComponents/AddressBlock'
import { getAddressObject } from 'components/Wizard2/WizardClasses'
import Markdown from 'components/Markdown/Markdown'
import { VALIDATE, MASK } from 'components/Wizard2/validate'
import { noop } from 'utilities'
import { FieldError } from 'components/Shell/Login/CreateAccount'
import './RequestCertificate.scss'

export default class RequestCertificate extends React.Component{
  state = {
    values: {
      requesterName: "",
      certType: "",
      certAmount: "1",
      delivery:
        this.props.config.ALLOW_MAIL && !this.props.config.ALLOW_EMAIL
          ? "mail"
          : !this.props.config.ALLOW_MAIL && this.props.config.ALLOW_EMAIL
            ? "email"
            : "",
      address: getAddressObject(),
      email: ""
    },
    globalError: false,
    errors: {}
  }
  setError = () => {
    this.setState({
      globalError: true
    })
  }
  setValue = (value, key) => {
    this.setState(state => ({
      values: {
        ...state.values,
        [key]: value
      }
    }))
  }
  validate = () => {
    let errors = {}
    let deferredValidators = []

    if(!this.props.hideNameField && this.state.values.requesterName === ''){
      errors.requesterName = ["The name of the requester is required."]
    }
    if(this.state.values.certType === ''){
      errors.certType = ["A certificate type must be selected."]
    }
    if(this.props.config.ALLOW_AMOUNT && (!this.state.values.certAmount || this.state.values.certAmount === "0")){
      errors.certAmount = ["You must input a number of certificates greater than 0."]
    }
    if(!this.props.hideAddressBlock && this.state.values.delivery === ''){
      errors.delivery = ["A delivery address must be selected."]
    }
    if(this.state.values.delivery === 'email'){
      if(!this.state.values.email){
        errors.email = ["An email is required"]
      }
      else if(this.state.values.email.split('@').length !== 2 || this.state.values.email.split('.').length < 2){
        errors.email = ["Must be a properly formatted email"]
      }
    }
    if(this.state.values.delivery === 'mail'){
      deferredValidators.push(
        new Promise((resolve, reject) => {
          VALIDATE.addressIsValid(this.state.values.address, {}, {}, (isValid, error) => {
            if(isValid === false){
              resolve(error)
            }else{
              resolve()
            }
          })
        })
      )
      deferredValidators.push(
        new Promise((resolve, reject) => {
          VALIDATE.addressIsRequired(this.state.values.address, {}, {}, (isValid, error) => {
            if(isValid === false){
              resolve(error)
            }else{
              resolve()
            }
          })
        })
      )
    }
    Promise.all(deferredValidators).then(addressErrors => {
      this.setState({errors: {
        ...errors,
        address: addressErrors.filter(err => err)
      }})
      if(Object.keys(errors).length === 0){
        this.props.onCertificateRequested({...this.state.values})
      }
    })
  }
  getErrors = key => {
    return this.state.errors[key] ? this.state.errors[key] : []
  }
  getIsValid = key => {
    return getValidityClass(this.state.errors[key] ? this.state.errors[key].length > 0 ? false : null : null)
  }
  render(){
    const { ALLOW_EMAIL, ALLOW_MAIL, ALLOW_AMOUNT, CERTIFICATION_TYPES=[], INSTRUCTIONS } = (this.props.config || {})
    return(
      <form className="request-certificate wizard">
        {
          INSTRUCTIONS &&
          <Markdown className="instructions" source={INSTRUCTIONS} />
        }
        {this.props.hideNameField ?
          null
          :
          <DumbField label="Requester name" errorMessage={this.getErrors("requesterName")} required>
            <TextInput
              validityClass={this.getIsValid("requesterName")}
              width="100%"
              value={this.state.values.requesterName}
              placeholder="John Doe"
              onChange={value => {this.setValue(value, 'requesterName')}}
            />
          </DumbField>
        }
        <DumbField label="Certificate type" errorMessage={this.getErrors("certType")} required>
          <Select
            validityClass={this.getIsValid("certType")}
            value={this.state.values.certType}
            onChange={value => {this.setValue(value, 'certType')}}
            onBlur={noop}
            options={[
              {value: "", label: "[Select a certificate type]"},
              ...CERTIFICATION_TYPES
            ]}
          />
        </DumbField>
        {
          ALLOW_AMOUNT &&
          <DumbField label="Number of Certificates" errorMessage={this.getErrors("certAmount")} required>
            <TextInput
              validityClass={this.getIsValid("certAmount")}
              value={this.state.values.certAmount}
              onChange={value => {this.setValue(MASK.onlyNumbers(value), 'certAmount')}}
              onBlur={noop}
            />
          </DumbField>
        }
        {
          ALLOW_MAIL && ALLOW_EMAIL &&
          <DumbField label="Delivery method" errorMessage={this.getErrors("delivery")} required>
            <RadioInput
              value={this.state.values.delivery}
              onChange={value => {this.setValue(value, 'delivery')}}
              onBlur={noop}
              options={[
                {value: "email", label: "Email"},
                {value: "mail", label: "Traditional mail"}
              ]}
            />
          </DumbField>
        }
        {
          this.props.hideAddressBlock ?
            null
            :
            this.state.values.delivery === 'mail' &&
            <DumbField label={process.env.CERTIFICATION_ADDRESS_LABEL || "Delivery address"} errorMessage={this.getErrors("address")} required>
              <AddressBlock
                isValid={(this.state.errors.address || []).length > 0 ? false : null}
                width='100%'
                value={this.state.values.address}
                onChange={value => {this.setValue(value, 'address')}}
                showCityStateZip
                allowSelection={false}
                singleColSize='col-12'
                triColSizes={{
                  CITY: 'col-4',
                  STATE: 'col-4',
                  POSTAL_CODE: 'col-4'
                }}
              />
            </DumbField>
        }
        {
          this.state.values.delivery === 'email' &&
          <DumbField label="Email address" errorMessage={this.getErrors("email")} required>
            <TextInput
              validityClass={this.getIsValid("email")}
              width="100%"
              value={this.state.values.email}
              placeholder="example@email.com"
              onChange={value => {this.setValue(value, 'email')}}
            />
          </DumbField>
        }
        {
          this.state.globalError &&
          <FieldError>Something went wrong while requesting your certificate. Please try again later, and if the problem persists contact customer support.</FieldError>
        }
        <div className='controls'>
          <button type="button" className='btn btn-primary btn-raised' onClick={this.validate}>
            Request a Certificate
          </button>
        </div>
      </form>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Certificates/RequestCertificate.js